import React, { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import "chart.js/auto";

function AdsAnalyticsSidebar() {
  const [rawData, setRawData] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [adFilter, setAdFilter] = useState("all");
  const [deviceFilter, setDeviceFilter] = useState("all");
  const [countryFilter, setCountryFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // ================= FETCH =================
  useEffect(() => {
    fetch("https://www.bharatabroad.com/api/track-ad-click-review")
      .then((res) => res.json())
      .then((data) => {
        setRawData(data.data || []);
        setFiltered(data.data || []);
      });
  }, []);

  // ================= FILTER =================
  useEffect(() => {
    let data = [...rawData];

    if (adFilter !== "all") data = data.filter((d) => d.adId === adFilter);
    if (deviceFilter !== "all")
      data = data.filter((d) => d.deviceType === deviceFilter);
    if (countryFilter !== "all")
      data = data.filter((d) => d.country === countryFilter);

    if (startDate)
      data = data.filter((d) => new Date(d.timestamp) >= new Date(startDate));
    if (endDate)
      data = data.filter((d) => new Date(d.timestamp) <= new Date(endDate));

    setFiltered(data);
  }, [rawData, adFilter, deviceFilter, countryFilter, startDate, endDate]);

  // ================= PROCESS =================
  const adCounts = {};
  const deviceCounts = {};
  const dailyCounts = {};
  const hourlyCounts = {};

  filtered.forEach((d) => {
    adCounts[d.adId] = (adCounts[d.adId] || 0) + 1;
    deviceCounts[d.deviceType] = (deviceCounts[d.deviceType] || 0) + 1;

    const day = new Date(d.timestamp).toLocaleDateString();
    dailyCounts[day] = (dailyCounts[day] || 0) + 1;

    const hour = new Date(d.timestamp).getHours();
    hourlyCounts[hour] = (hourlyCounts[hour] || 0) + 1;
  });

  const smallChart = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true } },
  };

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {/* ================= SIDEBAR FILTERS ================= */}
        <div className="col-md-2">
          <div className="card p-3 shadow-sm">
            <h6>Filters</h6>

            <label className="mt-2">Ad</label>
            <select
              className="form-control mb-2"
              onChange={(e) => setAdFilter(e.target.value)}
            >
              <option value="all">All</option>
              {[...new Set(rawData.map((d) => d.adId))].map((ad) => (
                <option key={ad}>{ad}</option>
              ))}
            </select>

            <label>Device</label>
            <select
              className="form-control mb-2"
              onChange={(e) => setDeviceFilter(e.target.value)}
            >
              <option value="all">All</option>
              <option value="mobile">Mobile</option>
              <option value="desktop">Desktop</option>
            </select>

            <label>Country</label>
            <select
              className="form-control mb-2"
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="all">All</option>
              {[...new Set(rawData.map((d) => d.country))].map((c) => (
                <option key={c}>{c}</option>
              ))}
            </select>

            <label>From</label>
            <input
              type="date"
              className="form-control mb-2"
              onChange={(e) => setStartDate(e.target.value)}
            />

            <label>To</label>
            <input
              type="date"
              className="form-control mb-2"
              onChange={(e) => setEndDate(e.target.value)}
            />

            <button
              className="btn btn-secondary btn-sm mt-2"
              onClick={() => {
                setAdFilter("all");
                setDeviceFilter("all");
                setCountryFilter("all");
                setStartDate("");
                setEndDate("");
              }}
            >
              Reset
            </button>
          </div>
        </div>

        {/* ================= CHART AREA ================= */}
        <div className="col-md-10">
          {/* ROW 1 — CLICKS PER AD */}
          <div className="card p-3 mb-3 shadow-sm">
            <h6>Clicks per Ad</h6>
            <div style={{ height: "250px" }}>
              <Bar
                data={{
                  labels: Object.keys(adCounts),
                  datasets: [{ data: Object.values(adCounts) }],
                }}
                options={smallChart}
              />
            </div>
          </div>

          {/* ROW 2 — DEVICE */}
          <div className="card p-3 mb-3 shadow-sm">
            <h6>Device Wise</h6>
            <div style={{ height: "250px" }}>
              <Bar
                data={{
                  labels: Object.keys(deviceCounts),
                  datasets: [{ data: Object.values(deviceCounts) }],
                }}
                options={smallChart}
              />
            </div>
          </div>

          {/* ROW 3 — DATE + TIME */}
          <div className="row">
            <div className="col-md-6">
              <div className="card p-3 shadow-sm">
                <h6>Date Wise</h6>
                <div style={{ height: "180px" }}>
                  <Line
                    data={{
                      labels: Object.keys(dailyCounts),
                      datasets: [{ data: Object.values(dailyCounts) }],
                    }}
                    options={smallChart}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card p-3 shadow-sm">
                <h6>Time Wise</h6>
                <div style={{ height: "180px" }}>
                  <Line
                    data={{
                      labels: Object.keys(hourlyCounts),
                      datasets: [{ data: Object.values(hourlyCounts) }],
                    }}
                    options={smallChart}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdsAnalyticsSidebar;
